// The shared Product Transfer Type Code list (DE 521) — used by PAD02
// across transaction sets, and by PTD01 in the 867. Union of the 844's
// original PAD02 codes, the 845's, and the 867's PTD01 codes, per
// reference/session/845-price-authorization-acknowledgment-status-qualifiers-txt.md
// (all of the 845's codes are already present in the 844's set) and
// reference/session/867-product-transfer-and-resale-report-qualifiers-txt.md.
// The home for this DE going forward: a future transaction set's PAD02 or
// PTD01 should extend this list rather than defining its own.

import type {CodeListEntry} from './types';

export const PRODUCT_TRANSFER_TYPE_CODES: CodeListEntry[] = [
  {code: 'SD', label: 'Ship and Debit Sale'},
  {code: 'SH', label: 'Ship and Debit'},
  {code: 'SS', label: 'Stock Sale'},
  {code: 'DS', label: 'Drop Ship Sale'},
  {code: 'CS', label: 'Contract Sale'},
  {code: 'PA', label: 'Price adjustment'},
  {code: 'IB', label: 'Interbranch'},
  {code: 'RV', label: 'Return to Vendor'},
  {code: 'BN', label: 'Return'},
  {code: 'RC', label: 'Received From Vendor'},
  {code: 'IA', label: 'Inventory adjustment'},
  {code: 'SA', label: 'Stocking adjustment'},
  {code: 'SU', label: 'Summary'},
  {code: 'BB', label: 'Demand Information Only'},
];
